import get from "lodash/get";

const _ = { get };

export default {
  inject: { sserrors: { default: () => ({}) } }, // tego się pozbyć

  data() {
    return {
      sserrorsLocal: ""
    };
  },

  mounted() {
    this.sserrorsLocal = this.sserrors;
  },

  computed: {
    sserror() {
      return !this.preferredValidator.$dirty
        ? _.get(this.sserrorsLocal.errors, this.name.replace("$each.", ""), "")
        : "";
    },

    activeErrorMessagesBoth() {
      const errorKey =
        this.activeErrorMessages && this.activeErrorMessages.length
          ? this.activeErrorMessages[0]
          : this.sserror.length
          ? this.sserror
          : "";
      const errorMessage = this.$t(errorKey);

      return errorMessage;
    },

    hasErrorsBoth() {
      return this.hasErrors || this.sserror.length > 0;
    }
  },
  watch: {
    activeErrorMessagesBoth: function(newValue) {
      this.$store.commit("Form/setError", {
        path: `form.${this.name}`,
        msg: newValue
      });
    }
  }
};
